import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './store';
import { initializeFromStorage, verifyToken, refreshAccessToken, logout } from './store/authSlice';
import { fetchFeatureFlags } from './store/featureFlagsSlice';
import { fetchBanner } from './store/bannerSlice';
import { initializeApiHelpers } from './utils/api';

// Инициализируем API helpers после создания store
initializeApiHelpers(store, { refresh: refreshAccessToken, logout });

// const root = ReactDOM.createRoot(
//   document.getElementById('root') as HTMLElement
// );
store.dispatch(initializeFromStorage()).finally(() => {
  store.dispatch(verifyToken());
  // Публичные feature-флаги и баннер: грузим даже для гостей.
  // В runtime обновятся через WS-события `feature-flags` и `banner`.
  store.dispatch(fetchFeatureFlags());
  store.dispatch(fetchBanner());
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <HelmetProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </HelmetProvider>
  );
});
